<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <h1 class="page-title">My files</h1>

        @if (loading) {
            <p class="state-text">Loading…</p>
        } @else if (groups.length === 0) {
            <p class="state-text">You don't have any categories assigned yet.</p>
        } @else if (!hasAnyFiles) {
            <p class="state-text">There are no files available in your categories yet.</p>
        } @else {
            @for (g of groups; track g.categoryId) {
                <section class="category-block">
                    <h2 class="category-title">
                        <fa-icon [icon]="faFolderOpen"></fa-icon>
                        {{ g.categoryName }}
                        <span class="count">{{ g.files.length }}</span>
                    </h2>

                    @if (g.files.length === 0) {
                        <p class="empty">No files in this category.</p>
                    } @else {
                        <div class="file-list">
                            @for (f of g.files; track f.id) {
                                <div class="file-row">
                                    <div class="file-info">
                                        <span class="file-title">{{ f.title }}</span>
                                        @if (f.descr) {
                                            <span class="file-descr">{{ f.descr }}</span>
                                        }
                                        @if (f.realFilename) {
                                            <span class="file-name">{{ f.realFilename }}</span>
                                        }
                                    </div>
                                    <button type="button" class="download-btn" (click)="download(f)"
                                        ngbTooltip="Download" container="body">
                                        <fa-icon [icon]="faDownload"></fa-icon>
                                    </button>
                                </div>
                            }
                        </div>
                    }
                </section>
            }
        }
    </div>
</div>

<app-footer></app-footer>
